/* eslint-disable jsx-a11y/anchor-is-valid */
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment';
import React, { useContext, useEffect, useState } from "react";
import { useMutation } from 'react-query';
import { OptionModel, TblComOfferingType } from '../../models';
import { UserContext } from "../../Provider";
import { httpGET } from '../../utils/ajaxHelper';
import { oklchToSRGB } from '../../utils/convertOklchToRgb';
import { DashboardIndex } from "./componentIndex";
import { IDashboardProps } from "./dashboard.props";
import { StateDashBoardProviderProvider } from './stateDashBoardProvider';

export const Dashboard: React.FC<IDashboardProps> = ({ ...props }) => {
    const user = useContext(UserContext);

    const filterByTimeOptions = user?.userConfiguration.dateRangeOption;
    const [filterByTime, setfilterByTime] = useState<any>(filterByTimeOptions![0]);
    const [comOfferingTypes, setComOfferingTypes] = useState<OptionModel[]>([])
    const [orgFilters, setOrgFilters] = useState<OptionModel[]>([])
    const [chooseComOfferingType, setChooseComOfferingType] = useState<OptionModel>()
    const [orgFilter, setOrgFilter] = useState<OptionModel>()


    const { mutate: getOrgFilter, } = useMutation(
        () =>
            httpGET({
                url: "/DashboardReport/filter-org",
            }),
        {
            onSuccess: (rs) => {
                const options = (rs as OptionModel[])?.map((e: any) => ({
                    label: e.label,
                    value: e.value,
                    isDefault: e.isDefault,
                })) ?? [] as OptionModel[]

                setOrgFilters(options);
                setOrgFilter(options.find(o => o.isDefault))
            },
        },
    );

    const { mutate: getComOfferingTypes, } = useMutation(
        () =>
            httpGET({
                url: "/DashboardReport/comoffering-type",
            }),
        {
            onSuccess: (rs) => {
                const options = (rs as TblComOfferingType[])?.map(e => ({
                    label: e.offeringTypeName,
                    value: e.offeringTypeId
                })) ?? []

                setComOfferingTypes(options);
                setChooseComOfferingType(options?.[0] ?? undefined)
            },
        },
    );

    useEffect(() => {
        getComOfferingTypes()
        getOrgFilter()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onCloneExportPdf = (document: any) => {
        const elements = document.getElementsByTagName('*');
        for (let i = 0; i < elements.length; i++) {
            const el = elements[i] as HTMLElement;
            const style = window.getComputedStyle(el);

            if (style.color.includes('oklch')) {
                const [l, c, h] = style.color.match(/\d+(\.\d+)?/g)?.map(Number) || [0, 0, 0];
                const rgbColor = oklchToSRGB(l, c, h);
                el.style.color = `rgb(${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]})`;
            }

            if (style.backgroundColor.includes('oklch')) {
                const [l, c, h] = style.backgroundColor.match(/\d+(\.\d+)?/g)?.map(Number) || [0, 0, 0];
                const rgbBgColor = oklchToSRGB(l, c, h);
                el.style.backgroundColor = `rgb(${rgbBgColor[0]}, ${rgbBgColor[1]}, ${rgbBgColor[2]})`;
            }
        }
    }

    const exportToPDF = () => {
        const element = document.getElementById('captureDesktop');
        if (!element) return;

        html2canvas(element, {
            backgroundColor: "#e4e4e4",
            scale: 2,
            width: 1142,
            useCORS: true,
            removeContainer: true,
            onclone: onCloneExportPdf
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF({
                unit: 'mm',
                format: 'a4',
            });

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const marginInMM = 5;
            const availableWidth = pageWidth - (2 * marginInMM);
            const availableHeight = pageHeight - (2 * marginInMM);

            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = imgWidth / imgHeight;

            let finalWidth = availableWidth;
            let finalHeight = availableWidth / ratio;

            if (finalHeight > availableHeight) {
                finalHeight = availableHeight;
                finalWidth = availableHeight * ratio;
            }

            const x = marginInMM;
            const y = marginInMM;

            pdf.addImage(imgData, 'PNG', x, y, finalWidth, finalHeight);
            addFooters(pdf);
            pdf.save(user?.fileNamePrintPdf || 'document.pdf');
        });
    }
    const addFooters = (doc: jsPDF) => {
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;

        doc.setFontSize(8);
        doc.text(moment(new Date()).format("MM/DD/YYYY HH:mm:ss"), pageWidth - 31, pageHeight - 4);
    };



    return (
        <>
            <StateDashBoardProviderProvider>
                <DashboardIndex
                    isAllowMobile={true}
                    isHidden={false}
                    exportToPDF={exportToPDF}
                    comOfferingTypes={comOfferingTypes}
                    chooseComOfferingType={chooseComOfferingType}
                    setChooseComOfferingType={setChooseComOfferingType}

                    orgFilters={orgFilters}
                    orgFilter={orgFilter}
                    setOrgFilter={setOrgFilter}

                    filterByTimeOptions={
                        filterByTimeOptions ?? []
                    }
                    filterByTime={filterByTime}
                    setfilterByTime={setfilterByTime}
                />

                <DashboardIndex
                    isAllowMobile={false}
                    isHidden={true}
                    comOfferingTypes={comOfferingTypes}
                    chooseComOfferingType={chooseComOfferingType}
                    setChooseComOfferingType={setChooseComOfferingType}

                    orgFilters={orgFilters}
                    orgFilter={orgFilter}
                    setOrgFilter={setOrgFilter}

                    filterByTimeOptions={
                        filterByTimeOptions ?? []
                    }
                    filterByTime={filterByTime}
                    setfilterByTime={setfilterByTime}
                />
            </StateDashBoardProviderProvider>
        </>
    )
}

export default React.memo(Dashboard);
